import { URGENCY_COLORS, URGENCY_LABELS } from "../../lib/constants";

export default function UrgencyBadge({ urgency }) {
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${URGENCY_COLORS[urgency]}`}>
      {URGENCY_LABELS[urgency]}
    </span>
  );
}
